<template>
  <full-container :padding="0">
    <div slot="header" class="toolbar">
      <el-input size="small" v-model="queryParams.keyWord" clearable style="width: 240px" placeholder="单位/姓名/电话关键字">
        <el-button slot="append" class="el-icon-search" @click="onSearch()" />
      </el-input>
    </div>
    <el-table ref="tb" :data="datalist.Items" height="100%" @selection-change="handleSelectionChange">
      <el-table-column prop="Customer.Name" label="单位名称" min-width="160" show-overflow-tooltip />
      <el-table-column prop="User.Name" label="姓名" min-width="120" />
      <el-table-column prop="User.Phone" label="手机号" min-width="120" />
      <el-table-column type="selection" width="55" align="center" />
    </el-table>

    <div class="toolbar" slot="footer">
      <el-pagination layout="prev, next" :page-size="datalist.PageSize" :current-page="datalist.PageIndex" :total="datalist.TotalCount" @current-change="onSearch" />
      <el-button type="primary" size="samll" @click="onSelect">确定</el-button>
    </div>
  </full-container>
</template>

<script>
export default {
  data () {
    return {
      phone: null,
      queryParams: { index: 1, size: 20 },
      datalist: {},
      selection: []
    }
  },
  props: {
    customerId: { type: String },
    multiple: { type: Boolean, default: false },
    callback: { type: Function },
    layerid: { type: String, default: null }
  },
  created () {
    this.loadData()
  },
  methods: {
    // 查询参数
    onSearch (val = 1) {
      this.queryParams.index = val
      this.loadData()
    },
    //获取数据
    loadData () {
      this.$apis.organize.customer.user.list({
        ...this.queryParams,
        customerId: this.customerId
      }).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      })
    },

    // 多选框选中数据
    handleSelectionChange (e) {
      if (this.multiple) {
        this.selection = e
      }
      else {
        this.selection = e[0]
        if (e.length > 1) {
          this.$refs.tb.clearSelection()
          this.$refs.tb.toggleRowSelection(e.pop())
        }
      }
    },
    //确定返回
    onSelect () {
      this.callback(this.selection)
      this.$layer.close(this.layerid)
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  padding: 10px;
  li {
    list-style: none;
    display: flex;
    align-items: center;
    padding: 10px;
    .el-link {
      font-size: 16px;
      margin-right: 10px;
    }
  }
}
</style>